// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1O_7C","inner":"Form_inner__PhosH","range":"Form_range__1Az7q","name":"Form_name__tzFqT","actions":"Form_actions__LJfDU"};